import { render, staticRenderFns } from "./EditSimpleArticleModal.vue?vue&type=template&id=2ad1a958"
import script from "./EditSimpleArticleModal.vue?vue&type=script&lang=ts"
export * from "./EditSimpleArticleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports